const _excluded = ["page"];var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(arg) {var key = _toPrimitive(arg, "string");return typeof key === "symbol" ? key : String(key);}function _toPrimitive(input, hint) {if (typeof input !== "object" || input === null) return input;var prim = input[Symbol.toPrimitive];if (prim !== undefined) {var res = prim.call(input, hint || "default");if (typeof res !== "object") return res;throw new TypeError("@@toPrimitive must return a primitive value.");}return (hint === "string" ? String : Number)(input);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { withRouter } from "../componentWrappers";
import { RequestParams } from "../utils/RequestParams";
import { actions } from "../BasicReducer";
import { isClient, events } from "../utils";
import { toUrlParams } from "../../shared/JSONRequest";
import { ConnectedViewer as Viewer } from "./components/Viewer";
import entitiesAPI from "../Entities/EntitiesAPI";
import { leaveEditMode } from "./actions/documentActions";
import { searchParamsFromSearchParams } from "../utils/routeHelpers";
import { scrollToPage, activateReference } from "./actions/uiActions";
import { requestViewerState } from "./actions/routeActions";

const defaultDoc = (entity) => entity.get('defaultDoc') ? entity.get('defaultDoc').toJS() : {};

class PDFViewComponent extends Component {
  static async requestState(requestParams, globalResources) {
    return requestViewerState(
      requestParams.add({ raw: requestParams.data.raw === 'true' || !isClient }),
      globalResources
    );
  }

  constructor(props, context) {
    super(props, context);
    this.changeBrowserHistoryPage = this.changeBrowserHistoryPage.bind(this);
    this.changePage = this.changePage.bind(this);
    this.onDocumentReady = this.onDocumentReady.bind(this);
  }

  componentDidMount() {
    const query = searchParamsFromSearchParams(this.props.searchParams);
    if (query.searchTerm) {
      this.context.store.dispatch(actions.set('viewer.sidepanel.tab', 'text-search'));
    }
  }

  componentWillReceiveProps(props) {
    const currentQuery = searchParamsFromSearchParams(this.props.searchParams);
    const query = searchParamsFromSearchParams(props.searchParams);

    if (query.page !== currentQuery.page && query.raw !== 'true') {
      this.changePage(query.page);
    }
    if (
    (query.page !== currentQuery.page || query.raw !== currentQuery.raw) &&
    query.raw === 'true')
    {
      entitiesAPI.
      getRawPage(new RequestParams({ _id: defaultDoc(props.entity)._id, page: query.page })).
      then((pageText) => {
        this.context.store.dispatch(actions.set('viewer/rawText', pageText));
      });
    }
  }

  componentWillUnmount() {
    this.props.leaveEditMode();
  }

  onDocumentReady(doc) {
    events.emit('documentLoaded');
    const query = searchParamsFromSearchParams(this.props.searchParams);

    if (query.raw === 'true') {
      return;
    }
    if (query.page) {
      scrollToPage(query.page, 0);
    }
    const { ref } = query;
    if (ref) {
      const reference = doc.get('relations').find((r) => r.get('_id') === ref);
      this.context.store.dispatch(activateReference(reference.toJS()));
    }
  }

  changePage(nextPage) {
    const { raw = 'false' } = searchParamsFromSearchParams(this.props.searchParams);

    if (String(raw).toLowerCase() === 'false') {
      return scrollToPage(nextPage);
    }

    return this.changeBrowserHistoryPage(nextPage);
  }

  changeBrowserHistoryPage(newPage) {
    const _searchParamsFromSear = searchParamsFromSearchParams(this.props.searchParams),{ page } = _searchParamsFromSear,queryWithoutPage = _objectWithoutProperties(_searchParamsFromSear, _excluded);

    this.props.navigate(
      `${this.props.location.pathname}${toUrlParams(_objectSpread(_objectSpread({}, queryWithoutPage), {}, { page: newPage }))}`
    );
  }

  render() {
    const query = searchParamsFromSearchParams(this.props.searchParams);
    const page = Number(query.page || 1);
    const { pathname } = this.props.location;
    const raw = query.raw === 'true' || !isClient;

    return /*#__PURE__*/(
      React.createElement(React.Fragment, null, /*#__PURE__*/
      _jsx(Helmet, {}, void 0, raw && /*#__PURE__*/_jsx("link", { rel: "canonical", href: `${pathname}?page=${page}` })), /*#__PURE__*/
      _jsx(Viewer, {
        raw: raw,
        searchTerm: query.searchTerm,
        onPageChange: this.changeBrowserHistoryPage,
        onDocumentReady: this.onDocumentReady,
        changePage: this.changePage,
        page: page,
        file: defaultDoc(this.props.entity) }
      )
      ));

  }
}

PDFViewComponent.contextTypes = {
  store: PropTypes.instanceOf(Object)
};












PDFViewComponent.defaultProps = {
  leaveEditMode: () => {}
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ leaveEditMode }, dispatch);
}

const SSRPDFView = connect(null, mapDispatchToProps)(withRouter(PDFViewComponent));
const PDFView = Object.assign(SSRPDFView, { requestState: PDFViewComponent.requestState });
export { PDFView, PDFViewComponent };